module.exports = __webpack_public_path__ + "assets/img/my-vip-pop-bg.264c251c.png";